/**
 * Ripple Effects Module
 * Adds Material Design-style ripple animations to interactive elements
 */

/**
 * Initialize ripple effect listeners
 */
export function initializeRippleEffects() {
    document.addEventListener('click', handleRippleClick);
}

/**
 * Handle click events for ripple effect
 * @param {MouseEvent} e - Click event
 */
function handleRippleClick(e) {
    const button = e.target.closest('.btn, .filter-btn, .add-to-cart, .submit-btn');
    if (!button) return;

    createRipple(button, e.clientX, e.clientY);
}

/**
 * Create and animate ripple effect
 * @param {HTMLElement} element - Target element
 * @param {number} clientX - Click X coordinate
 * @param {number} clientY - Click Y coordinate
 */
function createRipple(element, clientX, clientY) {
    const ripple = document.createElement('span');
    const rect = element.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = clientX - rect.left - size / 2;
    const y = clientY - rect.top - size / 2;

    // Apply ripple styles
    Object.assign(ripple.style, {
        width: `${size}px`,
        height: `${size}px`,
        left: `${x}px`,
        top: `${y}px`,
        position: 'absolute',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.6)',
        transform: 'scale(0)',
        animation: 'ripple 0.6s linear',
        pointerEvents: 'none'
    });

    // Ensure parent is positioned
    element.style.position = 'relative';
    element.style.overflow = 'hidden';

    // Add ripple and remove after animation
    element.appendChild(ripple);

    setTimeout(() => {
        ripple.remove();
    }, 600);
}

/**
 * Remove ripple effect listeners (cleanup)
 */
export function cleanupRippleEffects() {
    document.removeEventListener('click', handleRippleClick);
}
